import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { hasPermission, type PERMISSIONS } from '@/shared/config/permissions';
import { useAuth } from '@/features/auth/hooks/useAuth';
import * as ROUTES from '@/shared/constants/routes';

interface ProtectedRouteProps {
  permission?: keyof typeof PERMISSIONS;
}

export function ProtectedRoute({ permission }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, userData } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (permission && !hasPermission(userData, permission)) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
}
